module.exports = __webpack_public_path__ + "static/media/classicSampleImage.d56db3c7.PNG";